// import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { mainPageTitle } from "./config";
import * as serviceWorker from './serviceWorker';
// require('es6-promise').polyfill();
// require('isomorphic-fetch');

ReactDOM.render(mainPageTitle, document.getElementById('title'));
ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
